





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Enums/Data
import { ContractStatusCodes } from "@/models/contracts";

// Types
import { IProduct } from "@/models/products";

@Component({
  components: {
    "select-checkbox-filter": () =>
      import("@/components/app/global/dataFilters/selectCheckboxFilter.vue")
  }
})
export default class ReactivateStatusRestrictionField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IProduct["reactivate_status_restriction"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isRestricted = false;
  public savedValue: string[] | null = [];

  public options = [
    {
      value: ContractStatusCodes.ACTIVE,
      label: this.$t("_.active")
    },
    {
      value: ContractStatusCodes.AWAITING_ACTIVATION,
      label: this.$t("_.subscription_awaiting_activation_summary")
    },
    {
      value: ContractStatusCodes.PENDING,
      label: this.$t("_.subscription_pending_summary")
    },
    {
      value: ContractStatusCodes.SUSPENDED,
      label: this.$t("_.suspended")
    },
    {
      value: ContractStatusCodes.CANCELLED,
      label: this.$t("_.cancelled")
    },
    { value: ContractStatusCodes.CLOSED, label: this.$t("_.lapsed") }
  ];

  // Methods

  public created() {
    this.isRestricted = !this.$_.isNull(this.value);
    this.savedValue = this.isRestricted ? this.value : [];
  }

  public isRestrictedChanged() {
    this.$emit("input", this.isRestricted ? this.savedValue : null);
  }

  // Getters

  public get reactivateStatusRestriction() {
    return this.value;
  }

  // Watchers

  @Watch("reactivateStatusRestriction")
  public onReactivateStatusRestrictionChange(value, oldValue) {
    this.savedValue = oldValue;
  }

  @Watch("value")
  public onPassedValueChange() {
    this.isRestricted = !this.$_.isNull(this.value);
  }
}
